import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/api/client';
import type { ForgotPasswordRequest } from '@lov/shared';

export function useForgotPassword() {
  return useMutation({
    mutationFn: async (data: ForgotPasswordRequest) => {
      const response = await apiClient.post('/auth/forgot-password', data);
      return response.data;
    },
  });
}
